import { Identifiable, Project, ProjectBudgetSynthesis } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function getProjectBudgetSynthesis(httpClient: HttpClient) {
  return (project: Identifiable<Project>, date: string) =>
    httpClient.sendHttpRequest<ProjectBudgetSynthesis>({
      endpoint: `/projects/${project.uuid}/budget?date=${date}`,
      method: HttpMethods.GET,
    });
}

export { getProjectBudgetSynthesis };
